const deepLinkCodes = new Map();

const storageKey = (flow, email) =>
  `${flow}:${String(email).trim().toLowerCase()}`;

export const rememberDeepLinkVerificationCode = (flow, email, code) => {
  if (!email || !code) {
    return;
  }
  deepLinkCodes.set(storageKey(flow, email), String(code));
};

export const getDeepLinkVerificationCode = (flow, email) => {
  if (!email) {
    return "";
  }
  return deepLinkCodes.get(storageKey(flow, email)) ?? "";
};

export const clearDeepLinkVerificationCode = (flow, email) => {
  if (!email) {
    return;
  }
  deepLinkCodes.delete(storageKey(flow, email));
};

export const resolveDeepLinkVerificationCode = (flow, email, codeFromSearch) => {
  if (codeFromSearch) {
    rememberDeepLinkVerificationCode(flow, email, codeFromSearch);
    return codeFromSearch;
  }
  return getDeepLinkVerificationCode(flow, email);
};
